import * as types from '../actions';

export default function(state = [], action) {
    const response = action.response;
    let timeVar = '~~'+Date.now(); 
    switch(action.type) {

        case types.FCM_NOTIFI_TOKEN_SAVE_SUCCESS:
            if(response.status===200){
                return {
                    ...state, 
                    fcmNotifiTokenSaveStatus: response.status,  
                    fcmNotifiTokenSaveActivity:types.FCM_NOTIFI_TOKEN_SAVE_SUCCESS,     
                };
            }
            else {
                return {
                    ...state,  
                    fcmNotifiTokenSaveStatus: response.status,  
                    fcmNotifiTokenSaveActivity:types.FCM_NOTIFI_TOKEN_SAVE_ERROR, 
                    fcmNotifiTokenSaveErrorData:response.data                              
                };
            }
        
        case types.FCM_NOTIFI_TOKEN_SAVE_ERROR:
            return {
                ...state,  
                fcmNotifiTokenSaveStatus: response.status,  
                fcmNotifiTokenSaveActivity:types.FCM_NOTIFI_TOKEN_SAVE_ERROR, 
                fcmNotifiTokenSaveErrorData:response.data                              
            };


        case types.FCM_NOTIFICATION_SEND_SUCCESS:
            if(response.status===200){
                return {
                    ...state, 
                    fcmNotificationSendStatus: response.status,  
                    fcmNotificationSendActivity:types.FCM_NOTIFICATION_SEND_SUCCESS,     
                };
            }
            else {
                return {
                    ...state,  
                    fcmNotificationSendStatus: response.status,  
                    fcmNotificationSendActivity:types.FCM_NOTIFICATION_SEND_ERROR, 
                    fcmNotificationSendErrorData:response.data                              
                };
            }

        case types.FCM_NOTIFICATION_SEND_ERROR:
            return {
                ...state,  
                fcmNotificationSendStatus: response.status,  
                fcmNotificationSendActivity:types.FCM_NOTIFICATION_SEND_ERROR, 
                fcmNotificationSendErrorData:response.data                              
            };


        case types.NOTIFICATIONS_FETCH_SUCCESS:
            if(response.status===200){
                return {
                    ...state, 
                    notificationsFetchData: response.data,  
                    notificationsFetchStatus: response.status,  
                    notificationsFetchActivity:types.NOTIFICATIONS_FETCH_SUCCESS+timeVar,     
                };
            }
            else {
                return {
                    ...state,  
                    notificationsFetchStatus: response.status,  
                    notificationsFetchActivity:types.NOTIFICATIONS_FETCH_ERROR+timeVar, 
                    notificationsFetchErrorData:(response.data) ? (response.data) : [],
                };
            }

        case types.NOTIFICATIONS_FETCH_ERROR:
            return {
                ...state,  
                notificationsFetchStatus: response.status,  
                notificationsFetchActivity:types.NOTIFICATIONS_FETCH_ERROR+timeVar, 
                notificationsFetchErrorData:(response.data) ? (response.data) : [],          
            };
        
        
        case types.NOTIFICATION_READ_SUCCESS:
            if(response.status===200){
                return {
                    ...state, 
                    notificationReadStatus: response.status,  
                    notificationReadActivity:types.NOTIFICATION_READ_SUCCESS+timeVar,      
                };
            }
            else {
                return {
                    notificationReadStatus: response.status,  
                    notificationReadActivity:types.NOTIFICATION_READ_ERROR+timeVar,  
                    notificationReadErrorData:(response.data) ? (response.data) : [],                             
                };
            }

        case types.NOTIFICATION_READ_ERROR:
            return {
                notificationReadStatus: response.status,  
                notificationReadActivity:types.NOTIFICATION_READ_ERROR+timeVar,  
                notificationReadErrorData:(response.data) ? (response.data) : [],                              
            };

    
        case types.NOTIFICATIONS_FETCH_DROPDOWN_SUCCESS:
            if(response.status===200){
                return {
                    ...state, 
                    notificationsFetchDropDownData: response.data,  
                    notificationsFetchDropDownStatus: response.status,  
                    notificationsFetchDropDownActivity:types.NOTIFICATIONS_FETCH_DROPDOWN_SUCCESS+timeVar,     
                };
            }
            else {
                return {
                    ...state,  
                    notificationsFetchDropDownStatus: response.status,  
                    notificationsFetchDropDownActivity:types.NOTIFICATIONS_FETCH_DROPDOWN_ERROR+timeVar, 
                    notificationsFetchDropDownErrorData:(response.data) ? (response.data) : [],
                };
            }

        case types.NOTIFICATIONS_FETCH_DROPDOWN_ERROR:
            return {
                ...state,  
                notificationsFetchDropDownStatus: response.status,  
                notificationsFetchDropDownActivity:types.NOTIFICATIONS_FETCH_DROPDOWN_ERROR+timeVar, 
                notificationsFetchDropDownErrorData:(response.data) ? (response.data) : [],          
            };    



        case types.NOTIFICATIONS_ALL_MARK_AS_READ_SUCCESS:
            if(response.status===200){
                console.log('notificationsAllRead response.data: '+JSON.stringify(response.data)); 
                return {
                    ...state, 
                    notificationsAllReadData: response.data,  
                    notificationsAllReaStatus: response.status,  
                    notificationsAllReaActivity:types.NOTIFICATIONS_ALL_MARK_AS_READ_SUCCESS+timeVar,     
                };
            }
            else {
                return {
                    ...state,  
                    notificationsAllReaStatus: response.status,  
                    notificationsAllReaActivity:types.NOTIFICATIONS_ALL_MARK_AS_READ_ERROR+timeVar, 
                    notificationsAllReaErrorData:(response.data) ? (response.data) : [],
                };
            }

        case types.NOTIFICATIONS_ALL_MARK_AS_READ_ERROR:
            return {
                ...state,  
                notificationsAllReaStatus: response.status,  
                notificationsAllReaActivity:types.NOTIFICATIONS_ALL_MARK_AS_READ_ERROR+timeVar, 
                notificationsAllReaErrorData:(response.data) ? (response.data) : [],          
            }; 

        default:
            return state;
    
        }
    }